module.exports = "/* push-config styles */\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/push/push-config/push-config.component.css
// module id = ./src/app/components/push/push-config/push-config.component.css
// module chunks = main